// Global Types
// import type {
//   $AccessTokenPayload,
// } from 'common.types';

// Global Emums
// import {
//   AccessTokenKey,
//   AccessTokenType,
// } from 'common.types';

// Helpers
import moment from 'moment';
// import {
//   generateAccessToken,
// } from '@vroskus/library-auth';

// Enums
import {
  AdminAccessTokenAuthType,
  AdminAccessTokenStatus,
  AdminStatus,
  CrewmemberLanguage,
  GroupType,
  RegattaDocumentStatus,
  RegattaEntryCrewmemberGender,
  RegattaEntryCrewmemberTshirt,
  RegattaGroupRatingType,
  RegattaMessageType,
  RegattaRegistrationStatus,
  RegattaRequirementType,
  RegattaStatus,
} from './enums';

// Types
import type {
  $Model,
} from '.';
import type {
  $FullAdminRegatta,
  $FullChampionship,
  $FullRegatta,
  $FullRegattaEntry,
  $FullRegattaGroup,
  $FullRegion,
  $FullWebRegatta,
  $RegattaEntryResource,
} from './types';

const now: moment.Moment = moment().startOf('hour');
const nowMoment = () => now.clone();

const createdAt = nowMoment().toDate();
const updatedAt = nowMoment().toDate();

export const regions: Array<$Model<'Region'>> = [{
  createdAt,
  DateFormat: 'YYYY-MM-DD',
  Domain: 'lt',
  Flag: 'LT',
  id: 'a6899812-9b9b-4f5e-903e-9b809cceabb3',
  Name: 'Region 0',
  RegistrationLetters: 'LTU',
  ShortDateFormat: 'MM.DD',
  TimeFormat: 'HH:mm',
  Timezone: 'Europe/Vilnius',
  updatedAt,
}];

export const regionSeasons: Array<$Model<'RegionSeason'>> = [{
  createdAt,
  EndDate: nowMoment().endOf('year').toDate(),
  id: '4627bac6-2667-424d-9c13-51090c26c64b',
  Name: 'RegionSeason 0',
  RegionId: regions[0].id,
  StartDate: nowMoment().startOf('year').toDate(),
  updatedAt,
}, {
  createdAt,
  EndDate: nowMoment().subtract(
    1,
    'year',
  ).endOf('year').toDate(),
  id: 'fac8fb2f-e97b-43f9-a0c9-77e49dc0d2d2',
  Name: 'RegionSeason 1',
  RegionId: regions[0].id,
  StartDate: nowMoment().subtract(
    1,
    'year',
  ).startOf('year').toDate(),
  updatedAt,
}];

export const fullRegions: Array<$FullRegion> = [{
  ...regions[0],
  RegionSeasons: regionSeasons,
}];

export const admins: Array<$Model<'Admin'>> = [{
  createdAt,
  Email: 'admin-0@test.com',
  id: 'ff55edbf-d3d0-4049-a773-5a3a8bc176ce',
  InvoiceAddress: null,
  InvoiceName: null,
  InvoiceNo: null,
  InvoiceVat: null,
  Name: 'admin',
  Password: 'password',
  Phone: '123',
  RemoteImage: null,
  Review: false,
  Status: AdminStatus.confirmed,
  Super: true,
  updatedAt,
}];

export const adminAccessTokens: Array<$Model<'AdminAccessToken'>> = [{
  AdminId: admins[0].id,
  Agent: {
    browser: 'browser',
    city: 'city',
    country: 'country',
    ip: 'ip',
    os: 'os',
    platform: 'platform',
  },
  AuthType: AdminAccessTokenAuthType.local,
  createdAt,
  Exp: nowMoment().add(
    1,
    'month',
  ).toDate(),
  id: '5293ad49-ea8a-48c1-a5e9-e0da3767fe78',
  Name: 'admin-access-token',
  Status: AdminAccessTokenStatus.valid,
  updatedAt,
}];

// const adminAccessTokenPayload: $AccessTokenPayload = {
//   exp: nowMoment().add(
//     1,
//     'month',
//   ).unix(),
//   id: admins[0].id,
//   tokenId: adminAccessTokens[0].id,
//   tokenType: AccessTokenType.admin,
// };

// const adminAccessToken = generateAccessToken({
//   payload: adminAccessTokenPayload,
//   secret: 'secret',
// });

// export const adminAccessTokenCookie = `${AccessTokenKey.admin}=${adminAccessToken}`;

export const adminAccessTokenCookie = 'adminAccessToken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3NjcyMjU1OTksImlkIjoiZmY1NWVkYmYtZDNkMC00MDQ5LWE3NzMtNWEzYThiYzE3NmNlIiwidG9rZW5JZCI6IjUyOTNhZDQ5LWVhOGEtNDhjMS1hNWU5LWUwZGEzNzY3ZmU3OCIsInRva2VuVHlwZSI6IkFETUlOIiwiaWF0IjoxNjY3NjkwNjg0fQ.IbSIREqcHQ81g9OTgUOGUtsAv9TUTIjP4GZdjz7DnM0';

export const groups: Array<$Model<'Group'>> = [{
  createdAt,
  CrewQuantity: 0,
  id: 'f1b1799d-500e-4538-af82-791862f0ac43',
  Image: null,
  Name: 'CruiserGroup',
  Type: GroupType.cruiser,
  updatedAt,
}, {
  createdAt,
  CrewQuantity: 1,
  id: '96bfe4fb-5eaa-43e8-929a-8fcbb23a4543',
  Image: null,
  Name: 'SportGroup',
  Type: GroupType.sport,
  updatedAt,
}];

export const regattas: Array<$Model<'Regatta'>> = [{
  BowNoEnabled: true,
  Canceled: false,
  Consent: 'Consent',
  Content: 'Regatta content',
  CountryEnabled: false,
  createdAt,
  EndDate: nowMoment().subtract(
    1,
    'day',
  ).toDate(),
  GeoLocation: 'Geo Location',
  GeoLocationLat: null,
  GeoLocationLng: null,
  GroupChangeEnabled: true,
  Highlight: true,
  id: '7d00d6c5-0aed-4733-becc-ead7f064722d',
  Image: null,
  Invoice: null,
  InvoiceAdminId: null,
  ListEnabled: true,
  Location: 'Location 0',
  Lock: false,
  Name: 'Regatta 0',
  OrganizerContact: 'OrganizerContact',
  OrganizerEmail: 'Organizer@test.com',
  OrganizerName: 'OrganizerName',
  PageEnabled: true,
  PreventDuplicateRegistrationNo: true,
  Public: true,
  ReferenceId: null,
  RegionSeasonId: regionSeasons[0].id,
  RegistrationBirthdateField: true,
  RegistrationClubField: true,
  RegistrationContent: 'RegistrationContent',
  RegistrationEmailField: true,
  RegistrationEnabled: true,
  RegistrationEndDate: null,
  RegistrationHarborField: true,
  RegistrationMembershipField: true,
  RegistrationStartDate: null,
  RegistrationStatus: RegattaRegistrationStatus.ended,
  RegistrationTshirtField: true,
  RegistrationWeightField: true,
  SailNoEnabled: false,
  Slug: 'regatta-0',
  StartDate: nowMoment().subtract(
    2,
    'day',
  ).toDate(),
  Status: RegattaStatus.ended,
  SubmitProtestEnabled: true,
  updatedAt,
}, {
  BowNoEnabled: true,
  Canceled: false,
  Consent: 'Consent',
  Content: 'Regatta content',
  CountryEnabled: false,
  createdAt,
  EndDate: nowMoment().add(
    1,
    'day',
  ).toDate(),
  GeoLocation: 'Geo Location',
  GeoLocationLat: null,
  GeoLocationLng: null,
  GroupChangeEnabled: true,
  Highlight: true,
  id: '016d7176-0597-4661-b1f1-3cfc6fe8e16f',
  Image: null,
  Invoice: null,
  InvoiceAdminId: null,
  ListEnabled: true,
  Location: 'Location 1',
  Lock: false,
  Name: 'Regatta 1',
  OrganizerContact: 'OrganizerContact',
  OrganizerEmail: 'Organizer@test.com',
  OrganizerName: 'OrganizerName',
  PageEnabled: true,
  PreventDuplicateRegistrationNo: true,
  Public: true,
  ReferenceId: null,
  RegionSeasonId: regionSeasons[0].id,
  RegistrationBirthdateField: true,
  RegistrationClubField: true,
  RegistrationContent: 'RegistrationContent',
  RegistrationEmailField: true,
  RegistrationEnabled: true,
  RegistrationEndDate: nowMoment().add(
    1,
    'hour',
  ).toDate(),
  RegistrationHarborField: true,
  RegistrationMembershipField: true,
  RegistrationStartDate: null,
  RegistrationStatus: RegattaRegistrationStatus.ongoing,
  RegistrationTshirtField: true,
  RegistrationWeightField: true,
  SailNoEnabled: false,
  Slug: 'regatta-1',
  StartDate: nowMoment().subtract(
    1,
    'day',
  ).toDate(),
  Status: RegattaStatus.ongoing,
  SubmitProtestEnabled: true,
  updatedAt,
}, {
  BowNoEnabled: true,
  Canceled: false,
  Consent: 'Consent',
  Content: 'Regatta content',
  CountryEnabled: false,
  createdAt,
  EndDate: nowMoment().add(
    2,
    'day',
  ).toDate(),
  GeoLocation: 'Geo Location',
  GeoLocationLat: null,
  GeoLocationLng: null,
  GroupChangeEnabled: true,
  Highlight: true,
  id: 'be33cec9-2826-4e5f-9abe-bfc21dcf93b8',
  Image: null,
  Invoice: null,
  InvoiceAdminId: null,
  ListEnabled: true,
  Location: 'Location 2',
  Lock: false,
  Name: 'Regatta 2',
  OrganizerContact: 'OrganizerContact',
  OrganizerEmail: 'Organizer@test.com',
  OrganizerName: 'OrganizerName',
  PageEnabled: true,
  PreventDuplicateRegistrationNo: true,
  Public: true,
  ReferenceId: null,
  RegionSeasonId: regionSeasons[0].id,
  RegistrationBirthdateField: true,
  RegistrationClubField: true,
  RegistrationContent: 'RegistrationContent',
  RegistrationEmailField: true,
  RegistrationEnabled: true,
  RegistrationEndDate: null,
  RegistrationHarborField: true,
  RegistrationMembershipField: true,
  RegistrationStartDate: null,
  RegistrationStatus: RegattaRegistrationStatus.ongoing,
  RegistrationTshirtField: true,
  RegistrationWeightField: true,
  SailNoEnabled: false,
  Slug: 'regatta-2',
  StartDate: nowMoment().add(
    1,
    'day',
  ).toDate(),
  Status: RegattaStatus.upcoming,
  SubmitProtestEnabled: true,
  updatedAt,
}];

export const regattaAdmins: Array<$Model<'RegattaAdmin'>> = [{
  AdminId: admins[0].id,
  createdAt,
  id: 'dda98ade-eb79-452a-82a1-908462e474f9',
  RegattaId: regattas[0].id,
  updatedAt,
}, {
  AdminId: admins[0].id,
  createdAt,
  id: '430a7a08-5083-469d-9016-a7e8f9dc2c03',
  RegattaId: regattas[1].id,
  updatedAt,
}, {
  AdminId: admins[0].id,
  createdAt,
  id: '78836f52-7c57-4204-b3b8-1bd6a3fee9f8',
  RegattaId: regattas[2].id,
  updatedAt,
}];

export const regattaGroups: Array<$Model<'RegattaGroup'>> = [{
  AltName: null,
  CoachEnabled: false,
  createdAt,
  CrewQuantityLimit: null,
  EntriesQuantityLimit: null,
  GroupId: groups[0].id,
  id: 'b11c8bb1-8f7b-4546-911d-fcfba37ce0ed',
  PreliminaryCrewQuantityEnabled: false,
  RatingType: RegattaGroupRatingType.monotype,
  RegattaId: regattas[0].id,
  updatedAt,
}, {
  AltName: 'AltName',
  CoachEnabled: true,
  createdAt,
  CrewQuantityLimit: null,
  EntriesQuantityLimit: null,
  GroupId: groups[1].id,
  id: '405a2a58-913c-4b35-899a-1b9db47d7a04',
  PreliminaryCrewQuantityEnabled: false,
  RatingType: RegattaGroupRatingType.monotype,
  RegattaId: regattas[0].id,
  updatedAt,
}, {
  AltName: null,
  CoachEnabled: false,
  createdAt,
  CrewQuantityLimit: null,
  EntriesQuantityLimit: null,
  GroupId: groups[0].id,
  id: 'f17dc9bf-36bd-4720-8c3f-70ab732930ae',
  PreliminaryCrewQuantityEnabled: true,
  RatingType: RegattaGroupRatingType.monotype,
  RegattaId: regattas[1].id,
  updatedAt,
}, {
  AltName: 'AltName',
  CoachEnabled: true,
  createdAt,
  CrewQuantityLimit: null,
  EntriesQuantityLimit: null,
  GroupId: groups[1].id,
  id: '98ee0c26-6d18-4e4d-bf4a-c9d10af31692',
  PreliminaryCrewQuantityEnabled: false,
  RatingType: RegattaGroupRatingType.monotype,
  RegattaId: regattas[1].id,
  updatedAt,
}, {
  AltName: null,
  CoachEnabled: false,
  createdAt,
  CrewQuantityLimit: null,
  EntriesQuantityLimit: null,
  GroupId: groups[0].id,
  id: '6ebdc248-f997-4883-8e6a-46cceb9f270b',
  PreliminaryCrewQuantityEnabled: false,
  RatingType: RegattaGroupRatingType.monotype,
  RegattaId: regattas[2].id,
  updatedAt,
}, {
  AltName: 'AltName',
  CoachEnabled: true,
  createdAt,
  CrewQuantityLimit: null,
  EntriesQuantityLimit: null,
  GroupId: groups[1].id,
  id: '8c3c6f8a-11d5-4d6b-86c8-b675cc9933f3',
  PreliminaryCrewQuantityEnabled: false,
  RatingType: RegattaGroupRatingType.monotype,
  RegattaId: regattas[2].id,
  updatedAt,
}];

export const fullRegattaGroups: Array<$FullRegattaGroup> = [{
  ...regattaGroups[0],
  Group: {
    ...groups[0],
  },
}, {
  ...regattaGroups[1],
  Group: {
    ...groups[1],
  },
}, {
  ...regattaGroups[2],
  Group: {
    ...groups[0],
  },
}, {
  ...regattaGroups[3],
  Group: {
    ...groups[1],
  },
}, {
  ...regattaGroups[4],
  Group: {
    ...groups[0],
  },
}, {
  ...regattaGroups[5],
  Group: {
    ...groups[1],
  },
}];

export const fullRegattas: Array<$FullRegatta> = [{
  ...regattas[0],
  RegattaGroups: [
    fullRegattaGroups[0],
    fullRegattaGroups[1],
  ],
  RegattaRequirements: [],
}, {
  ...regattas[1],
  RegattaGroups: [
    fullRegattaGroups[2],
    fullRegattaGroups[3],
  ],
  RegattaRequirements: [],
}, {
  ...regattas[2],
  RegattaGroups: [
    fullRegattaGroups[4],
    fullRegattaGroups[5],
  ],
  RegattaRequirements: [],
}];

export const fullAdminRegattas: Array<$FullAdminRegatta> = [{
  ...fullRegattas[0],
  Admins: admins,
  RegattaChecks: [],
}, {
  ...fullRegattas[1],
  Admins: admins,
  RegattaChecks: [],
}, {
  ...fullRegattas[2],
  Admins: admins,
  RegattaChecks: [],
}];

export const regionSeasonRegattaLocations: Array<$Model<'RegionSeasonRegattaLocation'>> = [{
  createdAt,
  GeoLocationLat: null,
  GeoLocationLng: null,
  id: '49490029-1cdd-4ac2-a063-1197bcedec42',
  Location: regattas[1].Location,
  RegionSeasonId: regionSeasons[0].id,
  updatedAt,
}];

export const entries: Array<$Model<'Entry'>> = [{
  Club: 'Club 0',
  createdAt,
  Harbor: 'Harbor 0',
  id: '2cab909b-b0ee-4941-b6f2-d9d096aeef85',
  Image: null,
  Model: 'Model 0',
  Name: 'Name 0',
  RegionId: regions[0].id,
  RegistrationNo: 'LTU-01',
  SailNo: 'LTU-01S',
  updatedAt,
}];

export const regattaEntries: Array<$Model<'RegattaEntry'>> = [{
  BowNo: '1',
  Club: 'Club 0',
  CoachEmail: null,
  CoachName: null,
  CoachPhone: null,
  Content: null,
  createdAt,
  EntryId: null,
  Harbor: 'Harbor 0',
  id: '2cab909b-b0ee-4941-b6f2-d9d096aeef85',
  Image: null,
  Lock: false,
  Model: 'Model 0',
  Name: 'Entry 0',
  PreliminaryCrewQuantity: null,
  RegattaGroupId: regattaGroups[0].id,
  RegattaId: regattas[1].id,
  RegistrationNo: 'LTU-01',
  SailNo: 'LTU-01S',
  TrackerId: null,
  Uid: 'regattaEntry0',
  updatedAt,
}];

export const regattaEntryCrewmembers: Array<$Model<'RegattaEntryCrewmember'>> = [{
  Birthdate: '2000-12-31',
  createdAt,
  Email: 'crewmeber@test.com',
  Gender: RegattaEntryCrewmemberGender.male,
  id: '11ceeaec-031f-487a-8d7c-633810845d9d',
  Membership: 'Membership',
  Name: 'RegattaCrewmember 1',
  Phone: '123',
  Qualification: 'Qualification',
  RegattaEntryId: regattaEntries[0].id,
  SortId: 1,
  Tshirt: RegattaEntryCrewmemberTshirt.l,
  updatedAt,
  Weight: 100,
}];

export const regattaEntryResources: Array<$RegattaEntryResource> = [{
  ...regattaEntries[0],
  Ratings: [],
  RegattaEntryCrewmembers: regattaEntryCrewmembers,
  RegattaGroup: fullRegattaGroups[0],
}];

export const fullRegattaEntries: Array<$FullRegattaEntry> = [{
  ...regattaEntryResources[0],
  RegattaEntryChecks: [],
  RegattaEntryRequirements: [],
}];

export const fullWebRegattas: Array<$FullWebRegatta> = [{
  ...fullRegattas[0],
  RegattaCourses: [],
  RegattaEntries: regattaEntries,
}, {
  ...fullRegattas[1],
  RegattaCourses: [],
  RegattaEntries: regattaEntries,
}, {
  ...fullRegattas[2],
  RegattaCourses: [],
  RegattaEntries: regattaEntries,
}];

export const regattaMessages: Array<$Model<'RegattaMessage'>> = [{
  Content: 'Some message',
  createdAt,
  File: 'some.file',
  id: '36f66dce-7d52-4f09-9b78-fe8005c16ed5',
  Name: 'Regatta message',
  Public: true,
  PublishDate: new Date('2021-12-31T23:59:59.000Z'),
  RegattaId: regattas[1].id,
  Type: RegattaMessageType.organizingAuthority,
  updatedAt,
}];

export const regattaDocuments: Array<$Model<'RegattaDocument'>> = [{
  Content: 'Some content',
  createdAt,
  DocumentDate: new Date('2021-12-31T23:59:59.000Z'),
  File: null,
  id: '56952285-ce04-4b76-9524-b63673406340',
  Name: 'Regatta document',
  Public: true,
  PublishDate: new Date('2021-12-31T23:59:59.000Z'),
  RegattaId: regattas[1].id,
  Status: RegattaDocumentStatus.confirmed,
  StatusContent: null,
  updatedAt,
}];

export const regattaContacts: Array<$Model<'RegattaContact'>> = [{
  createdAt,
  Email: 'email@test.com',
  id: 'a882d294-4bf6-458c-9521-a03c067cdc7c',
  Image: null,
  Name: 'Contact name',
  Phone: '+000000',
  RegattaId: regattas[1].id,
  Role: 'Role',
  updatedAt,
}];

export const regattaChecks: Array<$Model<'RegattaCheck'>> = [{
  createdAt,
  id: 'a4f16168-44be-413e-a690-1c39cd171548',
  Name: 'Check 1',
  RegattaId: regattas[1].id,
  updatedAt,
}];

export const regattaRequirements: Array<$Model<'RegattaRequirement'>> = [{
  Content: 'Description',
  createdAt,
  id: 'a4f16168-44be-413e-a690-1c39cd171548',
  Name: 'Requirement 1',
  RegattaId: regattas[1].id,
  Required: true,
  Source: null,
  Type: RegattaRequirementType.boolean,
  updatedAt,
}];

export const crewmembers: Array<$Model<'Crewmember'>> = [{
  Birthdate: null,
  createdAt,
  Email: 'crewmeber@test.com',
  id: '68aabfda-c1e1-456c-b9b3-78805452f83a',
  Language: CrewmemberLanguage.en,
  Membership: null,
  Name: 'Crewmember',
  Phone: null,
  Qualification: null,
  RemoteImage: null,
  updatedAt,
  Weight: null,
}];

export const championships: Array<$Model<'Championship'>> = [{
  Content: 'Championship description',
  createdAt,
  id: '314d7960-099e-4cf9-8ef2-594597a554cf',
  Image: null,
  Lock: false,
  Name: 'Championship 0',
  OrganizerEmail: 'Organizer@test.com',
  OrganizerName: 'OrganizerName',
  Public: true,
  ReferenceId: null,
  RegionSeasonId: regionSeasons[0].id,
  Slug: 'championship-0',
  updatedAt,
}];

export const fullChampionships: Array<$FullChampionship> = [{
  ...championships[0],
  Regattas: [
    regattas[0],
    regattas[1],
  ],
}];

export const championshipRegattas: Array<$Model<'ChampionshipRegatta'>> = [{
  ChampionshipId: championships[0].id,
  createdAt,
  id: '7401bde0-5adc-4538-a083-a663e22ef67f',
  RegattaId: regattas[0].id,
  updatedAt,
}, {
  ChampionshipId: championships[0].id,
  createdAt,
  id: '5df079b6-7dcc-42bb-a085-cf91d9f8a8e6',
  RegattaId: regattas[1].id,
  updatedAt,
}];

export const championshipAdmins: Array<$Model<'ChampionshipAdmin'>> = [{
  AdminId: admins[0].id,
  ChampionshipId: championships[0].id,
  createdAt,
  id: '8001d152-51fe-4969-97b7-3bf2bb15c211',
  updatedAt,
}];
